import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { Checkbox } from 'components/FormFieldsSimple/Checkbox';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class CheckBoxGroupField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        checkBoxProps: PropTypes.object,
      }),
    ).isRequired,
    columnsCount: PropTypes.number,
    gridRowGap: PropTypes.string,
  };

  static defaultProps = {
    columnsCount: 1,
    gridRowGap: '16px',
  };

  handleChange = (checkBoxValue, itemValue) => {
    const { input, onHandleChange } = this.props;

    input.onFocus();
    input.onBlur();

    const newValue = [...input.value];

    const currentIndex = (input.value || []).findIndex(
      (value) => value.key === itemValue,
    );

    if (currentIndex === -1) {
      newValue.push({ key: itemValue, value: checkBoxValue });
    } else {
      newValue[currentIndex] = { key: itemValue, value: checkBoxValue };
    }

    input.onChange(newValue);
    onHandleChange && onHandleChange(newValue, input.name);
  };

  render() {
    const {
      input,
      data,
      gridRowGap,
      columnsCount,
      labelClassName = '',
      label,
    } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <>
          {label && (
            <span className={`checkbox-left-label ${labelClassName}`}>
              {label}
            </span>
          )}
          <div
            className="form-fields-grid-container"
            style={{
              gridTemplateColumns: `repeat(${columnsCount}, minmax(0, 1fr))`,
              gridRowGap,
            }}
          >
            {data.map((checkboxItem, index) => {
              const checkboxItemObject = (input.value || []).find(
                (inputValueItem) => checkboxItem.value === inputValueItem.key,
              );
              const value = checkboxItemObject && checkboxItemObject.value;

              return (
                <Checkbox
                  {...checkboxItem}
                  key={index}
                  type="checkbox"
                  label={checkboxItem.title}
                  onChange={(value) => {
                    this.handleChange(value, checkboxItem.value);
                  }}
                  value={value}
                  name={input.name + index}
                />
              );
            })}
          </div>
        </>
      </ReduxFormElementWrapper>
    );
  }
}
